module.exports = {
    routesData : () => {
        return[
            {
                "Apache RR 310 NEGRO ROJO": 'spins/RR310/NegroRojo',
                "Apache RR 310 ROJO NEGRO": 'spins/RR310/RojoNegro',

                "Sport 100 ELS AZUL PETROLEO GRIS": 'spins/Sport100ELS/AzulPetroleoGris',
                "Sport 100 ELS GRIS": 'spins/Sport100ELS/Gris',
                "Sport 100 ELS NEGRO GRIS": 'spins/Sport100ELS/NegroGris',
                "Sport 100 ELS NEGRO ROJO": 'spins/Sport100ELS/NegroRojo',
                "Sport 100 ELS ROJO": 'spins/Sport100ELS/Rojo',

                "Sport 100 KLS NEGRO ROJO": 'spins/Sport100KLS/NegroRojo',
                "Sport 100 KLS NEGRO VERDE": 'spins/Sport100KLS/NegroVerde',

                "Stryker NEGRO AZUL": 'spins/Stryker125/NegroAzul',
                "Stryker NEGRO ROJO": 'spins/Stryker125/NegroRojo',
                "Stryker NEGRO VERDE": 'spins/Stryker125/NegroVerde',

                "Max 125 NEGRO AZUL": 'spins/Max125/NegroAzul',
                "Max 125 NEGRO ROJO": 'spins/Max125/NegroGris',
                "Max 125 NEGRO GRIS": 'spins/Max125/NegroRojo',

                "Apache 160 2V NEGRO": 'spins/Apache1602V/Negro',
                "Apache 160 2V GRIS": 'spins/Apache1602V/Gris',

                "Apache 160 4V GRIS AZUL": 'spins/Apache1604V/GrisAzul',
                "Apache 160 4V GRIS NEGRO": 'spins/Apache1604V/GrisNegro',
                "Apache 160 4V GRIS ROJO": 'spins/Apache1604V/GrisRojo',
                "Apache 160 4V ROJO NEGRO": 'spins/Apache1604V/RojoNegro',

                "Apache 180 2V NEGRO ROJO": 'spins/Apache1802V/NegroRojo',

                "Apache 200 2V NEGRO": 'spins/Apache2004V/Negro',
                "Apache 200 2V NEGRO ROJO": 'spins/Apache2004V/NegroRojo',

                "Apache 200 fi AZUL NEGRO": 'spins/200FI/AzulNegro',
                "Apache 200 fi ROJO NEGRO": 'spins/200FI/RojoNegro',

                "Raider 125 AMARILLO": 'spins/Raider/Amarillo',
                "Raider 125 AZUL": 'spins/Raider/Azul',
                "Raider 125 NEGRO": 'spins/Raider/Negro',
                "Raider 125 ROJO": 'spins/Raider/Rojo',

                "Ntorq 125 AZUL BLANCO NEGRO": 'spins/Ntorq125/AzulBlancoNegro',
                "Ntorq 125 BLANCO ROJO NEGRO": 'spins/Ntorq125/BlancoRojoNegro',
                "Ntorq 125 NEGRO AMARILLO": 'spins/Ntorq125/NegroAmarillo',
                "Ntorq 125 NEGRO GRIS": 'spins/Ntorq125/NegroGris',
                "Ntorq 125 NEGRO ROJO": 'spins/Ntorq125/NegroRojo',

                "Ntorq 125 Racing NEGRO ROJO": 'spins/Ntorq125Racing/NegroRojo',

                "Ntorq 125 fi NEGRO VERDE": 'spins/Ntorq125FI/NegroVerde',

                "Neo NX 110 GRIS AZUL": 'spins/NeoNX110/GrisAzul',
                "Neo NX 110 NEGRO ROJO": 'spins/NeoNX110/NegroRojo',
                "Neo NX 110 NEGRO VERDE": 'spins/NeoNX110/NegroVerde',

                "Motocarro King Basico BLANCO ROJO NEGRO": 'spins/MotoCarroGS/BlancoRojoNegro',

                "Motocarro King Carpa Especial BLANCO ROJO NEGRO": 'spins/MotoCarroGSEspecial/BlancoRojoNegro',

                "Motocarro King Carpa Full BLANCO ROJO NEGRO": 'spins/MotoCarroGSFull/BlancoRojoNegro',
            }
        ] 
    }
} 